<template>
  <component
    :is="to ? 'NuxtLink' : 'span'"
    :to="to ? to : null"
    :class="[
      'ucrs-anchor',
      {
        'ucrs-anchor--disabled': disabled,
        'ucrs-anchor--reverse': iconPosition == 'left',
        'ucrs-anchor--animation': animation == true,
      },
    ]"
    @click="$emit('click')"
    @click.native="$emit('click')"
  >
    <span class="ucrs-anchor__text" :class="[`ucrs-anchor__text--${fontSize}`]">
      {{ text }}
    </span>
    <SvgIcon
      :name="icon"
      :class="[
        'ucrs-anchor__icon',
        `ucrs-anchor__icon--${iconSize}`,
        {
          'ucrs-anchor__icon--left': iconPosition == 'left',
          'ucrs-anchor__icon--right': iconPosition == 'right',
          'ucrs-anchor__icon--disabled': disabled,
        },
      ]"
    />
  </component>
</template>

<script>
// Libs
import throttle from 'lodash/throttle'

export default {
  props: {
    label: {
      type: [String, Object],
      default: '',
    },
    icon: {
      type: String,
      default: 'angle-right',
    },
    iconPosition: {
      type: String,
      default: 'right',
    },
    iconSize: {
      type: String,
      default: 'sm',
    },
    fontSize: {
      type: String,
      default: 'sm',
    },
    animation: {
      type: Boolean,
      default: false,
    },
    to: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      text: '',
      breakpoint: 1024,
    }
  },
  mounted() {
    if (typeof this.label === 'object') {
      this.text =
        window.innerWidth < this.breakpoint
          ? this.label.mobile
          : this.label.desktop
      window.addEventListener('resize', this.handleResize)
    } else {
      this.text = this.label
    }
  },
  destroyed() {
    if (typeof this.label === 'object')
      window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize: throttle(function () {
      if (typeof this.label === 'object') {
        this.text =
          window.innerWidth < this.breakpoint
            ? this.label.mobile
            : this.label.desktop
      } else {
        this.text = this.label
      }
    }, 100),
  },
}
</script>
